export default __webpack_public_path__ + "static/media/leftButton.a4eae5a5.svg";